var translations = {
    de: {
        title: 'Warum wir Ihnen Angebote erst nach individueller Prüfung anzeigen',
        point1: 'Bei smava gibt es keine Schaufenster-Zinsen.',
        point2: 'Für vertrauenswürdige Angebote benötigen wir Informationen zu Ihrer Person und finanziellen Situation.',
        point3: 'Wir erstellen für Sie auf Basis Ihrer eingegebenen Daten eine individuelle Bau-/Immobilienfinanzierung einer unserer über 450 regionalen und überregionalen Bankpartner.',
        point4: 'Wir finden deshalb auch eine Bank in Ihrer Nähe und vergleichen die für Sie verfügbaren Angebote.',
        point5: 'Dieses Angebot ist unverbindlich. Beim Vergleich von Bau-/Immobilienfinanzierungen wird die SCHUFA nicht von smava angefragt.',
        buttonTitle: 'Bau-/Immobilienfinanzierung vergleichen',
    },
};
export default translations;
